<script>
  import DialogBase from "../dialog/DialogBase.svelte";
  import DialogTitleFixedAtTopWithCloseButton from "../dialog/DialogTitleFixedAtTopWithCloseButton.svelte";
  import { translate } from "../../i18n/i18next.js";
  import DialogSplitter from "../dialog/DialogSplitter.svelte";
  import DialogContent from "../dialog/DialogContent.svelte";

  export let dialog;
  export let onClose;

  export let commentsPromise;
</script>

<DialogBase bind:dialog>
  <DialogTitleFixedAtTopWithCloseButton
    title={translate("generic.comment")}
    {onClose}
  />

  {#await commentsPromise}
    <DialogSplitter />
    <DialogContent>
      <div class="loading">"Loading..."</div>
    </DialogContent>
  {:then comments}
    {#if comments && comments.Comments.length > 0}
      {#each comments.Comments.slice(0, 10) as comment}
        <DialogSplitter />
        <DialogContent extraStyle="padding: 16px; gap: 8px">
          <div class="comment-header">
            <span class="username">{comment["Username"]}</span>
            <span class="timestamp"
              >{new Date(comment.Timestamp).toLocaleString()}</span
            >
          </div>
          <div class="comment-text">{comment.Content}</div>
        </DialogContent>
      {/each}
    {/if}
  {:catch error}
    <DialogSplitter />
    <DialogContent>
      <div class="error">
        {error.message}
      </div>
    </DialogContent>
  {/await}
  <DialogSplitter />
</DialogBase>

<style>
  .comment-header {
    display: flex;
    justify-content: space-between;
    color: #666;
  }
  .username {
    font-weight: bold;
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .timestamp {
    font-size: 16px;
    color: gray;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .comment-text {
    font-size: 16px;
    white-space: pre-wrap; 
    word-wrap: break-word;
  }
</style>
